import React, { FC } from 'react';
import { getValueOrNA, VehicleInformation } from '@/ui/components';
import { useTranslate } from '@/translations';

import { Descriptions } from 'antd';
import { fieldRenderers } from './helpers';
import { OtherInspectionsTable } from '../OtherInspectionsTable';
import { InspectionUpdateRegNumber } from '../InspectionRegNumber';
import { Inspection } from '@/types';

type Fields = {
  [key in keyof Inspection]?: string;
};
interface InspectionCardProps {
  data: Inspection;
  fields: Fields;
  column?: number;
  layout?: 'vertical' | 'horizontal';
  size?: 'default' | 'middle' | 'small';
  canEdit?: boolean;
}
export const InspectionCard: FC<InspectionCardProps> = ({
  data,
  fields,
  column,
  layout,
  size,
  canEdit = false,
}) => {
  const { t } = useTranslate();
  const columnNum = column || 3;

  return (
    <Descriptions
      layout={layout || 'vertical'}
      column={columnNum}
      size={size || 'middle'}
      items={Object.entries(fields).map(([field, label]) => {
        if (field === 'regNumber') {
          return {
            key: field,
            label,
            children: (
              <InspectionUpdateRegNumber inspection={data} canEdit={canEdit} />
            ),
          };
        }
        if (field === 'otherInspections') {
          return {
            key: field,
            label,
            span: columnNum,
            children: <OtherInspectionsTable data={data.otherInspections} />,
          };
        }

        if (field === 'vin') {
          return {
            key: field,
            label,
            children: <VehicleInformation vin={data[field]} showAsLabel />,
          };
        }

        const value = fieldRenderers[field]
          ? fieldRenderers[field](data, t)
          : getValueOrNA(field)({ data });

        return {
          key: field,
          label,
          children: value,
          span: field === 'id' ? 2 : undefined,
        };
      })}
    />
  );
};
